import { QueryClient } from '@tanstack/react-query'

/**
 * The console's shared browser cache. Every piece of data a page shows but
 * does not own (integration summary, system health, skill names) is read
 * through this client, so any number of components on a page share one
 * request instead of each fetching on its own.
 *
 * Defaults: never retry a failed read on their own (the next interval or
 * visit asks again), refetch a stale read when the tab regains focus, and
 * never let an interval fire while the browser tab is hidden.
 */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: true,
        refetchIntervalInBackground: false,
      },
    },
  })
}

export const appQueryClient = createAppQueryClient()

/**
 * Forget everything the signed-in session cached. Called wherever the
 * session bootstrap is cleared (role change, sign-out, impersonation end),
 * so the next session never sees the previous one's data.
 */
export function resetSessionQueries() {
  appQueryClient.clear()
}
